






















































































import { Component, Vue } from 'vue-property-decorator'
import { apiMaterialCategoryList, apiMaterialCategoryDelete, apiMaterialCategoryStatus } from '@/api/material'

@Component
export default class MaterialCategory extends Vue {
    categoryList: any[] = []

    getCategoryList () {
      apiMaterialCategoryList().then((res: any) => {
        this.categoryList = res.lists || []
      })
    }

    getCategoryTypeText (type: number): string {
      const typeMap = [
        '',
        '保洁用品',
        '维修材料',
        '布草类',
        '易耗品',
        '设备配件',
        '办公用品',
        '食品饮料'
      ]
      return typeMap[type] || '其他'
    }

    getUnitTypeText (type: number): string {
      const unitMap = [
        '',
        '个',
        '件',
        '套',
        '瓶',
        '包',
        '卷',
        '米',
        '千克',
        '升'
      ]
      return unitMap[type] || '个'
    }

    handleAdd () {
      this.$router.push('/material/category_add')
    }

    handleAddChild (row: any) {
      this.$router.push({
        path: '/material/category_add',
        query: {
          pid: row.id,
          level: row.level + 1
        }
      })
    }

    handleEdit (row: any) {
      this.$router.push({
        path: '/material/category_edit',
        query: { id: row.id }
      })
    }

    handleDelete (row: any) {
      this.$confirm('确定要删除该分类吗？删除后无法恢复，且需确保该分类下无物料。', '警告', {
        type: 'warning',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        apiMaterialCategoryDelete({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.getCategoryList()
        })
      })
    }

    handleStatusChange (row: any) {
      apiMaterialCategoryStatus({
        id: row.id,
        is_enabled: row.is_enabled
      }).then(() => {
        this.$message.success('状态更新成功')
      })
    }

    handleRefresh () {
      this.getCategoryList()
    }

    created () {
      this.getCategoryList()
    }
}
